import React, { Component } from 'react';
import { object } from "prop-types";
import { connect } from 'react-redux';

const withReducer = (key, reducer) => WrappedComponent => {
    const Extended = (props, context) => {
        context.store.injectReducer(key, reducer);
        return <WrappedComponent {...props} />;
    };
    Extended.contextTypes = {
        store: object
    };
    return Extended;
};
export default withReducer;


// WEBPACK FOOTER //
// ./resources/assets/js/containers/withReducer.js